/* eslint-disable */
import lockScroll from '../__utils/lockScroll';

const $ = jQuery.noConflict();

class VideoLightbox {
	constructor() {
		this.trigger = $('.v-lightbox__trigger');
	}

	init() {
		this.trigger.each((i, e) => {
			const uniqid = $(e).data('v-target');
			const target = $(`[data-v-lightbox="${uniqid}"]`);
			const lightbox = target.clone();

			this.removeLightboxDefault(target);

			$(e).on('click', () => {
				this.open(lightbox);
			});

			$('body').on('click', '.v-lightbox__close', (e) => {
				const target = $(e.currentTarget).closest('.v-lightbox');
				this.close(target);
			});

			//Close by ESC
			$('body').on('keydown', (e) => {
				if (e.keyCode === 27) {
					this.close(lightbox);
				}
			});
		});
	}

	removeLightboxDefault(lightbox) {
		lightbox.remove();
	}

	open(lightbox) {
		const source = lightbox.find('source');
		const src = source.data('src');

		source.attr('src', src);

		$('.page-content').append(lightbox);
		if ($(lightbox).find('video').length > 0) {
			$(lightbox).find('video').get(0).load();
		} else {
			$(lightbox).load();
		}
		lightbox.fadeIn('300');
		lockScroll.lock();
	}

	close(lightbox) {
		lockScroll.unlock();
		lightbox.fadeOut('300', () => {
			lightbox.remove();
		});
	}
}

export default new VideoLightbox();
